import { useTeamConfig } from '../../../utils/teamConfig';

type UrlProps = {
  albumUrl: string;
  itemUrl: string;
};

export function useLibSearchListProps(): UrlProps {
  const props: UrlProps = {
    albumUrl: '/member/my/media/albums/search',
    itemUrl: '/member/my/medias/search',
  };
  const teamProps: UrlProps = {
    albumUrl: '/team/app/tours/media/albums/search',
    itemUrl: '/team/app/tours/media/search',
  };
  return useTeamConfig(props, teamProps);
}

type FetchType = 'images' | 'audios' | 'videos' | 'frames' | 'docs';

export function useLibFetchListProps(type: FetchType): UrlProps {
  const props: UrlProps = {
    albumUrl: `/member/my/media/${type}/albums`,
    itemUrl: `/member/my/medias/${type}`,
  };
  const teamProps: UrlProps = {
    albumUrl: `/team/app/tours/media/${type}/albums`,
    itemUrl: `/team/app/tours/medias/${type}`,
  };
  return useTeamConfig(props, teamProps);
}
